import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocEditorRoutingModule } from './doc-editor-routing.module';
import { DocEditorComponent } from './doc-editor.component';
import { SharedModule } from '../shared.module';
import { HeaderFooterSettingsComponent } from '../header-footer-settings/header-footer-settings.component';
import { InsertTableDialogComponent } from './insert-table-dialog/insert-table-dialog.component';
import { TablePropertiesDialogComponent } from './table-properties-dialog/table-properties-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';


@NgModule({
  declarations: [
    DocEditorComponent,
    HeaderFooterSettingsComponent,
    InsertTableDialogComponent,
    TablePropertiesDialogComponent
  ],
  imports: [
    CommonModule,
    DocEditorRoutingModule,
    SharedModule,
    MatSelectModule,
    MatDividerModule,
    MatMenuModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    FileUploadModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatToolbarModule

  ]
  , exports: [
    DocEditorComponent
  ]
})
export class DocEditorModule { }
